export default {
  vodafone: {
    id: 'product_page_telco_calculator_advertisement_vodafone',
    defaultMessage: 'Vodafone',
  },
  o2: {
    id: 'product_page_telco_calculator_advertisement_o2',
    defaultMessage: 'O2',
  },
  ee: {
    id: 'product_page_telco_calculator_advertisement_ee',
    defaultMessage: 'EE',
  },
}
